import { AvailableHotelModel } from '@/__generated';

export const encodePhoneNumber = (phone: string | undefined | null) => {
  if (phone && phone?.length >= 4) {
    return `********${phone.slice(-4)}`;
  }
  return phone;
};
export const getFullName = (firstName: any, lastName: any, title?: any) =>
  (title ? `${title}. ` : '') + [firstName, lastName].filter(x => x).join(' ');

export const getHotelName = (hotel: AvailableHotelModel) => {
  return [hotel?.hotelName, hotel?.originalName].join(' - ');
};
